<template>
    <div>
        <b-modal id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-move-excercise-to-folder" @hidden="resetModal">
            <div class="container wrap-form-change-name-class-school">
                <h4>
                    <strong>Thêm đề thi  {{ itemExcersice.name }} vào thư mục</strong>
                </h4>
                <b-form id="form-change-name-class-school" @submit.prevent="handleSave">
                    <div class="wrap-list-excersice">
                        <label for="name">Danh sách thư mục:</label>
                        <div class="row" ref="scrollContainer" id="listFolder">
                            <div class="col-md-12">
                                <b-form-radio-group v-model="form.folderId"
                                    :options="listDataFolder" stacked switches
                                    name="listFolder"></b-form-radio-group>
                            </div>
                        </div>
                    </div>
                    <span class="error display-block color-err font-size-14 text-left"
                        v-if="!$v.form.folderId.required && submitted">
                        Vui lòng chọn thư mục
                    </span>
                    <div class="form_action display-flex justity-content-space-around">
                        <button type="button"
                            class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading" @click="handleHideModal">
                            Hủy
                        </button>
                        <button type="submit"
                            class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading">
                            Thêm mới
                        </button>
                    </div>
                </b-form>
            </div>

        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { listFolderExcerciseClassSchool } from './../../../_api/folderExcerciseClassSchoolServices'
import {addListExcerciseToFolder} from './../../../_api/folderExcerciseClassSchoolServices'
export default {
    name: "ModalMoveExcerciseToFolder",
    props: {
        itemExcersice: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        }
    },
    components: {
       
    },
    data() {
        return {
            confirmActive: {},
            submitted: false,
            isLoading: false,
            form: {
                id:0,
                folderId: null,
            },
            listDataFolder:[],
            totalRecords: 0,
            totalPage: 0,
            paramQueryFolder:{
                keyword: '',
                pageIndex: 1,
                pageSize: 1000000,
            },
        }
    },
    validations() {
        return {
            form: {
                folderId: {
                    required,
                },
                
            }
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },

    },
    mounted() {
        this.handleShowModal()
        this.getListDataFolder()
    },

    methods: {
        handleSave() {
            let self = this
            this.submitted = true
            if (!this.$v.$invalid) {
                let params={
                    id:this.form.folderId,
                    listExcerciseId:[this.itemExcersice.id]
                }
                addListExcerciseToFolder(params).then(res=>{
                    if (res && res.data && !res.errors) {
                        self.$toast.success('Thêm đề thi vào thư mục thành công')
                        this.handleHideModal()
                        self.$emit('handleDone')
                    }
                })
            }
        },
        // handleScrollListLesson(){
        //     const container = this.$refs.scrollContainer;
        //     const scrollHeight = container.scrollHeight;
        //     const scrollTop = container.scrollTop;
        //     const offsetHeight = container.offsetHeight;
        //     const bottomOffset = scrollHeight - (scrollTop + offsetHeight);
        //     if (bottomOffset <= 0 && !this.isLoading) {
        //         console.log('get list data')
        //         let pageIndexSearch = this.paramQueryDataLesson.pageIndex + 1
        //         if (pageIndexSearch <= this.totalPage) {
        //             this.paramQueryDataLesson.pageIndex++
        //             this.getListLessonClassSchool()
        //         }

        //     }
        // },
        getListDataFolder() {
            let self = this
            listFolderExcerciseClassSchool(this.paramQueryFolder).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.list.length; i++) {
                        const item = res.data.list[i];
                        self.listDataFolder.push({ text:item.name,value:item.id })
                    }
                }
            })
        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        
        resetModal() {
            console.log('resetModal')
            this.submitted = false
            this.form = {
                userName: '',
            }
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-move-excercise-to-folder'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-move-excercise-to-folder'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-move-excercise-to-folder'].show()
        },
        
    }
}
</script>

<style lang="scss" scoped>

.wrap-form-change-name-class-school {
    padding-top: 20px;
    background-color: white;
    .wrap-list-excersice {
        margin-top: 20px;
    }

    #listFolder {
        overflow: auto;
        max-height: 10rem;
        border-radius: 15px;
        border: 1px solid #cdd4da;
        padding: 5px;
        background: #e5e5e5;
    }
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-around {
    justify-content: space-around
}
</style>